module.exports = __webpack_public_path__ + "static/media/md-speedometer.e976093c.svg";